import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { AppImage } from '../AppImage';
import { Container } from '../Container';
import { Reveal } from '../Reveal';
import type { Project } from '../../types/content';
interface NextCaseStudyProps {
  project: Project;
}
export function NextCaseStudy({
  project
}: NextCaseStudyProps) {
  return <section aria-labelledby="next-case-study" className="border-t border-hairline bg-surface" data-id="element-210" data-mp="12b2hxxe6jysz">
      <Container data-id="element-211" data-mp="179nk42czssk2">
        <Reveal data-id="element-212" data-mp="179410iblvy4g">
          <Link to={`/work/${project.slug}`} className="group grid gap-8 py-16 lg:grid-cols-12 lg:items-center lg:gap-10 lg:py-20" data-id="element-213" data-mp="17ayq88twucec">
            <div className="lg:col-span-7" data-id="element-214" data-mp="1h7thq7rrncj4">
              <p id="next-case-study" className="text-small text-muted" data-id="element-215" data-mp="1h9o5ruyc3krf">
                Next case study
              </p>
              {project.isConcept && <p className="mt-4 text-[12px] uppercase tracking-[0.06em] text-[#6E6E6E]" data-id="element-216" data-mp="2smqkslksc29h">
                  Self-initiated concept
                </p>}
              <h2 className={`max-w-[22ch] text-[28px] leading-[1.15] tracking-[-0.03em] text-ink lg:text-[40px] ${project.isConcept ? 'mt-3' : 'mt-4'}`} data-id="element-217" data-mp="z7ywc4w56iwh">
                {project.headline}
              </h2>
              <p className="mt-5 text-small text-muted" data-id="element-218" data-mp="laad11hq3jtj">
                {project.client} <span aria-hidden="true" data-id="element-219" data-mp="gc8t6ech3gh0">·</span> {project.outcome}
              </p>
              <span className="mt-7 inline-flex items-center gap-2 text-small text-accent transition-colors duration-150 ease-out group-hover:text-ink" data-id="element-220" data-mp="bkic7pj15ugm">
                Read it
                <ArrowRightIcon size={16} aria-hidden="true" className="transition-transform duration-200 ease-editorial group-hover:translate-x-1" data-id="element-221" data-mp="2kc64opnvwrh" />
              </span>
            </div>
            <AppImage src={project.image} alt={project.alt} ratio="4:3" className="lg:col-span-4 lg:col-start-9" imageClassName="transition-transform duration-500 ease-editorial group-hover:scale-[1.03]" data-id="element-222" data-mp="3os29as2w6pxj" />
          </Link>
        </Reveal>
      </Container>
    </section>;
}